import React from "react"

export default function Container({
  children,
  wide = false,
  className = "",
  style,
  ...props
}) {
  const maxWidth = wide ? null : "min(100%, 1440px)"
  return (
    <div
      className={`mx-auto px-8 ${className}`.trim()}
      style={{ ...style, maxWidth }}
      {...props}
    >
      {children}
    </div>
  )
}
